import { Center, Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TCommissionDataTableData = {
  primaryKey: string | number,
  id: string,
  name: string,
  effectiveDate: string,
  applyOnLigne: string,
};

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TCommissionDataTableData>();

export function getCommissionDataTableColumns({ isLoading }: Props) {
  return [
    columnHelper.accessor('id', {
      id: 'id',
      header: 'Id',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('name', {
      id: 'name',
      header: 'Nom',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('effectiveDate', {
      id: 'effectiveDate',
      header: 'Date Effe.',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('applyOnLigne', {
      id: 'applyOnLigne',
      header: 'Appliq. En-Ligne',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            <Center><Checkbox checked={!!props.getValue()} readOnly></Checkbox></Center>
          </Skeleton>;
      },
    }),    
  ];
}
